import type { MaintenanceWindow } from "./maintenance-api";

/** Active now: explicitly in progress, or (when bounded) within [start, end]. */
export function isActiveNow(w: MaintenanceWindow, now: number = Date.now()): boolean {
  if (w.status === "in_progress") {
    return true;
  }
  if (!w.endsAt) {
    return false;
  }
  const start = new Date(w.startsAt).getTime();
  const end = new Date(w.endsAt).getTime();
  return now >= start && now <= end;
}

/**
 * Worth surfacing under "Upcoming": a scheduled/in-progress window that is
 * either active now or starts in the future. Stale rows whose start (and end)
 * already passed but were never completed are excluded - they belong in the
 * full event history, not the upcoming list. Shared by the dashboard and the
 * maintenance page so the two never disagree.
 */
export function isUpcoming(w: MaintenanceWindow, now: number = Date.now()): boolean {
  if (w.status !== "scheduled" && w.status !== "in_progress") {
    return false;
  }
  return isActiveNow(w, now) || new Date(w.startsAt).getTime() > now;
}
